export class PreviewHandler {
    constructor() {
        this.preview = false;
        this.setPreview = (usePreview) => {
            this.preview = usePreview;
        };
        this.getPreviewHeaders = () => {
            return {
                preview: this.preview
            };
        };
    }
}
//# sourceMappingURL=PreviewHandler.js.map